import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
// import scLocale from './sc'
// import tcLocale from './tc'
import enLocale from './en'
import ruLocale from './ru'
// import jpLocale from './jp'
import esLocale from './es'
// import thLocale from './th'
// import hiLocale from './hi'
import ptLocale from './pt'
// import trLocale from './tr'
// import krLocale from './kr'

Vue.use(VueI18n)

const messages = {
  // sc: {
  //   ...scLocale
  // },
  // tc: {
  //   ...tcLocale
  // },
  en: {
    ...enLocale
  },
  ru: {
    ...ruLocale
  },
  // jp: {
  //   ...jpLocale
  // },
  es: {
    ...esLocale
  },
  // th: {
  //   ...thLocale
  // },
  // hi: {
  //   ...hiLocale
  // },
  pt: {
    ...ptLocale
  }
  // tr: {
  //   ...trLocale
  // },
  // kr: {
  //   ...krLocale
  // }
}

var MultLang = navigator.language || navigator.browserLanguage;
if(/^pt/.test(MultLang)) {
	MultLang = 'pt'
}else if(/^es/.test(MultLang)) {
  MultLang = 'es'
}else if(/^ru/.test(MultLang)) {
  MultLang = 'ru'
}else {
  MultLang = 'en'
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || MultLang,
  // set locale messages
  messages
})

export default i18n
